import { Component, Input } from '@angular/core';

@Component({
  selector: 'std-button',
  template: `
    <button
      [disabled]="disabled"
      [class]="
        'w-full  flex items-center justify-center rounded-[22px] min-h-10 p-3  ' +
        typeClass +
        buttonClass
      "
    >
      <ng-content class=""></ng-content>
    </button>
  `,
  styles: [
    `
      .primary-shadow {
        box-shadow: 2px 4px 12px 0px #0000001a;
      }

      .secondary-shadow {
        box-shadow: 2px 4px 6px 0px #0000000d inset;
        box-shadow: 2px 4px 12px 0px #0000001a;
      }
      .underline-content {
        text-decoration: underline;
        text-decoration-color: #47ad9f;
        text-underline-offset: 3px;
      }
      .underline-content:hover {
        text-decoration-color: #a2d5ce;
      }
      .underline-content:focus {
        text-decoration-color: #2e7268;
      }
      .underline-content:disabled,
      .underline-content[disabled] {
        text-decoration-color: #bec5c5;
      }
    `,
  ],
  standalone: false,
})
export class ButtonComponent {
  @Input() buttonClass: string = '';

  @Input() type: 'primary' | 'secondary' | 'tertiary' = 'primary';
  @Input() disabled: boolean = false;

  get typeClass(): string {
    switch (this.type) {
      case 'primary':
        return 'bg-primary text-white primary-shadow ';
      case 'secondary':
        return 'bg-white border-2 border-primary text-primary secondary-shadow ';
      case 'tertiary':
        return 'underline-content text bg-transparent text-primary ';
      default:
        return '';
    }
  }
}
